/**
 * Gestione Mense Backend Authentication API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { PastiCollaboratori } from './pastiCollaboratori';
import { PastiDocenti } from './pastiDocenti';
import { PastiPersonaleAta } from './pastiPersonaleAta';
import { PastiPersonaleTecnico } from './pastiPersonaleTecnico';

export interface PastiDipendenti { 
    id?: string;
    annoDiRiferimento?: string;
    numeroPastiTotaleDocenti?: number;
    numeroPastiTotalePersonaleAta?: number;
    numeroPastiTotaleCollaboratori?: number;
    numeroPastiTotalePersonaleTecnico?: number;
    pastiDocenti?: PastiDocenti;
    pastiPersonaleAta?: PastiPersonaleAta;
    pastiPersonaleTecnico?: PastiPersonaleTecnico;
    pastiCollaboratori?: PastiCollaboratori;
    created_at?: Date;
    updated_at?: Date;
}